const $overlay = $(".overlay"),
  $modalCloser = $(".modal-closer");

$("[data-modal]").on("click", function (e) {
  const modalID = "#" + $(this).attr("data-modal");
  if (modalID !== undefined) {
    e.preventDefault();
    showModal($(modalID));
  }
});

$modalCloser.on("click", function () {
  $(this).parent().parent().removeClass("active").css("top", "");
  hideOverlay();
});

$overlay.on("click", function (e) {
  if ($(e.target).closest("modal").length) return;
  $(".modal.active").removeClass("active").css("top", "");
  closeModal();
  hideOverlay();
});

const showOverlay = () => $overlay.addClass("active");
const hideOverlay = () => {
  setTimeout(() => {
    $overlay.removeClass("active");
  }, 300);
};

function showModal($modal) {
  const headerHeight = $('header').outerHeight(true) || 0;
  const modalHeight = $modal.outerHeight(true),
    $modalHead = $modal.find(".modal-head"),
    $modalBody = $modal.find(".modal-body"),
    windowHeight = $(window).height();
  let offsetTop = 0,
    modalBodyHeight = 0,
    headerOffset = headerHeight + 10;
  if (modalHeight > (windowHeight - headerOffset)) {
    offsetTop = headerOffset;
    modalBodyHeight =
      windowHeight - offsetTop * 2 - $modalHead.outerHeight(true);
    $modal.css("height", windowHeight - offsetTop * 2);
    $modalBody.css("height", modalBodyHeight).css("overflow-y", "scroll");
  } else {
    offsetTop = (windowHeight - modalHeight) / 2;
  }
  showOverlay();
  $modal.css("top", offsetTop).addClass("active");
}

const closeModal = () =>
  $(".modal.active").removeClass("active").css("top", "");
